export type SetOutRateMethod =
    | 'On-truck technology such as cameras, GPS, and/or RFID systems'
    | 'Periodic route audits'
    | 'Driver or inspector estimate'
    | 'Integrated with on-the-street contamination audits'
    | 'Other';

export const SETOUT_RATE_METHODS: SetOutRateMethod[] = [
     'On-truck technology such as cameras, GPS, and/or RFID systems',
     'Periodic route audits',
     'Driver or inspector estimate',
     'Integrated with on-the-street contamination audits',
     'Other'
];
